import { render, staticRenderFns } from "./modal_anamnese_detail.vue?vue&type=template&id=804e071e&scoped=true"
import script from "./modal_anamnese_detail.vue?vue&type=script&lang=js"
export * from "./modal_anamnese_detail.vue?vue&type=script&lang=js"
import style0 from "./modal_anamnese_detail.vue?vue&type=style&index=0&id=804e071e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "804e071e",
  null
  
)

export default component.exports